import { CSSObject } from "@emotion/react";

import { useMainBannerStore } from "@/stores/useMainBannerStore";

import { colors } from "@dotnet/telematics-design-system";

import useGeneralHeights from "../../shared/hooks/useGeneralHeights";

export const useStyles = () => {
  const mainBannerHeight = useMainBannerStore(state => state.height);

  const { NAVBAR_HEIGHT } = useGeneralHeights(mainBannerHeight);

  return {
    drawerDiv: {
      padding: "10px 24px 10px 24px",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center"
    },
    initialDrawerDiv: {
      padding: "10px 24px"
    },
    navbarControls: {
      "& > button": {
        display: "flex",
        justifyContent: "flex-start",
        marginTop: "8px",
        padding: "6px"
      }
    },
    listChoice: {
      background: colors.white,
      color: colors.blue700
    },

    navigationItems: {
      "& li + li": {
        marginTop: "8px"
      }
    },
    desktopdrawerAside: {
      position: "fixed",
      top: NAVBAR_HEIGHT,
      bottom: "0",
      zIndex: 1200,
      padding: "18px 15px 18px 16px",
      transition: "width 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms"
    },
    desktopdrawerContent: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      height: "100%"
    },
    navigationItem: {
      display: "flex",
      alignItems: "center",
      padding: "6px",
      borderRadius: "4px",
      overflowX: "hidden",
      transition:
        "background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms"
    },
    toggleDrawerIcon: { height: "24px" },

    additionalNavButton: {
      color: colors.gray700,
      cursor: "pointer",
      marginBottom: "8px",

      "&:hover": {
        backgroundColor: colors.gray200
      },

      "&:active": {
        backgroundColor: colors.gray200
      }
    },

    navItemTypography: {
      marginLeft: "8px",
      whiteSpace: "nowrap"
    }
  } as CSSObject;
};
